import React, { Component } from "react";
import "./stylesheets/jobcreate.css";
import Header from "../../components/header/Header";
import {
  getCreateJob,
  getAllCacheData,
  getSiteId,
  getTypeofWork,
  getProfile,
  getNotification,
  getTechnicians,
  getCustmor,
  getNotificationCount,
} from "../../modules/serverCall";
import { FloatingLabel, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import Multiselect from "multiselect-react-dropdown";
import withReactContent from "sweetalert2-react-content";
import Moment from "moment";
import Auth from "../../modules/Auth";
import moment from "moment";

export default class JobCreate extends Component {
  constructor(props) {
    super(props);
    var result = new Date();
    var mainDate = result.setDate(result.getDate() - 5);
    var dateData = new Date(mainDate);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    const displayName =
      readData.userdata.display_name + "-" + readData.userdata.sub;
    this.state = {
      currentdate: result,
      endDate: "",
      startDate: "",
      lasttdate: new Date(),
      selectedDate: "",
      customers: "",
      customer: "",
      department: "",
      convRef: "",
      typeofWorks: "",
      typeofWork: "",
      techn: [{ id: userId, name: displayName }],
      numbercasual: "",
      enddate: "",
      duration: "",
      measuresData: "",
      materialsData: "",
      measuresdatamainone: "",
      measuresdatamaintwo: "",
      measuresdatamainthree: "",
      measuresdatamainfour: "",
      measuresdatamainfive: "",
      measuresdatamainsix: "",
      materialsdatamainone: "",
      materialsdatamaintwo: "",
      materialsdatamainthree: "",
      materialsdatamainfour: "",
      materialsdatamainfive: "",
      materialsdatamainsix: "",
      materialsdatamainwone: "",
      materialsdatamainwtwo: "",
      materialsdatamainwthree: "",
      materialsdatamainwfour: "",
      materialsdatamainwfive: "",
      materialsdatamainwsix: "",
      materials: [],
      measures: [],
      customerState: [],
      inputEnabled: [],
      WorkMeasureMaterialID: {},
      errorClass: "",
      isError: {
        startDate: "",
        endDate: "",
        duration: "",
        customer: "",
        typeofWork: "",
        department: "",
        convRef: "",
        numbercasual: "",
        techn: "",
      },
    };
  }

  componentDidMount() {
    window.addEventListener("online", this.handleOfChange);
    window.scrollTo(0, 0);

    const fetchcustmor = async () => {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;
      const username = readData.userdata.username;
      var bodyData = {};
      var techDataMain = JSON.parse(localStorage.getItem("techData"));
      var workDataMain = JSON.parse(localStorage.getItem("workData"));
      var siteIdData = sessionStorage.getItem("siteID");
      if (
        siteIdData !== null &&
        siteIdData !== undefined &&
        siteIdData !== ""
      ) {
        siteIdData = localStorage.getItem("siteID");
      }
      if (
        siteIdData === "" ||
        siteIdData === null ||
        siteIdData === undefined ||
        workDataMain === "" ||
        workDataMain === null ||
        workDataMain === undefined ||
        techDataMain === "" ||
        techDataMain === null ||
        techDataMain === undefined
      ) {
        this.setState({
          lodingImagData: true,
        });
        var sendData = {
          techId: userId,
        };
        var res = await getSiteId(accesstokendata, userId);
        var resWork = await getTypeofWork(accesstokendata, username);
        var resProfile = await getProfile(userId);
        var resnoti = await getNotification(sendData);
        var notificationData = await getNotificationCount(sendData);
        if (res.status === 200) {
          var siteIdData = res.data.SiteID;
          sessionStorage.setItem("siteID", siteIdData);
          localStorage.setItem("siteID", siteIdData);
          var site = {
            siteID: siteIdData,
            date: moment(new Date()).format("YYYY-MM-DD"),
          };
          sessionStorage.setItem("siteID", siteIdData);
          localStorage.setItem("siteID", siteIdData);
          var resTech = await getTechnicians(accesstokendata, site);
          var resCust = await getCustmor(accesstokendata, siteIdData);
          if (
            resCust !== "" &&
            resCust !== null &&
            resCust !== undefined &&
            resTech !== "" &&
            resTech !== null &&
            resTech !== undefined
          ) {
            this.setState({
              lodingImagData: false,
            });
            if (notificationData.UnreadCount > 0) {
              var redirectData = "/notification-front";
              window.location.href = redirectData;
            }
          }
        } else {
          this.setState({
            lodingImagData: false,
          });
          var msg = "Please check your internet connection and try again";
          Swal.fire({
            title: "Slow internet",
            text: msg,
            icon: "error",
            showCancelButton: false,
            allowOutsideClick: false,
            cancelButtonColor: "#d33",
            confirmButtonText: "Ok",
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              Auth.logout();
            }
          });
        }
      }
      // else{
      //   var msg = 'Please check your internet connection and try again';
      //   Swal.fire({
      //     title: 'Slow internet',
      //     text: msg,
      //     icon: 'error',
      //     showCancelButton: false,
      //     allowOutsideClick:false,
      //     cancelButtonColor: '#d33',
      //     confirmButtonText: 'Ok',
      //     reverseButtons: true,
      //     }).then((result) => {
      //     if (result.isConfirmed) {
      //       Auth.logout();
      //     }
      //   })
      // }
    };
    fetchcustmor();
  }

  change = (e) => {
    e.preventDefault();
    let materials = this.state.materials;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|-\.)/, "");
    var dataName = e.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    if (nameSplite[2] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      materials[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: value,
      };
    } else {
      materials[nameSplite[1]] = { [e.target.name]: value };
    }
    this.setState({ materials });
  };

  changeMaterials = (e) => {
    e.preventDefault();
    let materials = this.state.materials;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|-\.)/, "");
    var dataName = e.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    if (nameSplite[2] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      materials[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: value,
      };
      if (nameSplite[2] === "0") {
        this.setState({ materialsdatamainone: value });
      } else if (nameSplite[2] === "1") {
        this.setState({ materialsdatamaintwo: value });
      } else if (nameSplite[2] === "2") {
        this.setState({ materialsdatamainthree: value });
      } else if (nameSplite[2] === "3") {
        this.setState({ materialsdatamainfour: value });
      } else if (nameSplite[2] === "4") {
        this.setState({ materialsdatamainfive: value });
      } else if (nameSplite[2] === "5") {
        this.setState({ materialsdatamainsix: value });
      }
    } else {
      var nameData = nameSplite[0] + nameSplite[1];
      var seconData = "WorkMeasureMaterialID" + nameSplite[1];
      var valuedata = this.state.WorkMeasureMaterialID;
      materials[nameSplite[1]] = { [nameData]: value, [seconData]: valuedata };
      if (nameSplite[1] === "0") {
        this.setState({ materialsdatamainwone: value });
      } else if (nameSplite[1] === "1") {
        this.setState({ materialsdatamainwtwo: value });
      } else if (nameSplite[1] === "2") {
        this.setState({ materialsdatamainwthree: value });
      } else if (nameSplite[1] === "3") {
        this.setState({ materialsdatamainwfour: value });
      } else if (nameSplite[1] === "4") {
        this.setState({ materialsdatamainwfive: value });
      } else if (nameSplite[1] === "5") {
        this.setState({ materialsdatamainwsix: value });
      }
    }
    this.setState({ materials });
  };

  changeMaterialsDec = (e) => {
    e.preventDefault();
    let materials = this.state.materials;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|-\.)/, "");
    var dataName = e.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,1})?)/g.exec(val);
    const value = match[1] + match[2];
    if (nameSplite[2] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      materials[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: value,
      };
      if (nameSplite[2] === "0") {
        this.setState({ materialsdatamainone: value });
      } else if (nameSplite[2] === "1") {
        this.setState({ materialsdatamaintwo: value });
      } else if (nameSplite[2] === "2") {
        this.setState({ materialsdatamainthree: value });
      } else if (nameSplite[2] === "3") {
        this.setState({ materialsdatamainfour: value });
      } else if (nameSplite[2] === "4") {
        this.setState({ materialsdatamainfive: value });
      } else if (nameSplite[2] === "5") {
        this.setState({ materialsdatamainsix: value });
      }
    } else {
      var nameData = nameSplite[0] + nameSplite[1];
      var seconData = "WorkMeasureMaterialID" + nameSplite[1];
      var valuedata = this.state.WorkMeasureMaterialID;
      materials[nameSplite[1]] = { [nameData]: value, [seconData]: valuedata };
      if (nameSplite[1] === "0") {
        this.setState({ materialsdatamainwone: value });
      } else if (nameSplite[1] === "1") {
        this.setState({ materialsdatamainwtwo: value });
      } else if (nameSplite[1] === "2") {
        this.setState({ materialsdatamainwthree: value });
      } else if (nameSplite[1] === "3") {
        this.setState({ materialsdatamainwfour: value });
      } else if (nameSplite[1] === "4") {
        this.setState({ materialsdatamainwfive: value });
      } else if (nameSplite[1] === "5") {
        this.setState({ materialsdatamainwsix: value });
      }
    }
    this.setState({ materials });
  };

  changeMeasures = (e) => {
    e.preventDefault();
    let measures = this.state.measures;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|-\.)/, "");
    var dataName = e.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,2})?)/g.exec(val);
    const value = match[1] + match[2];
    if (nameSplite[1] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      measures[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: value,
      };
      if (nameSplite[2] === "0") {
        this.setState({ measuresdatamainone: value });
      } else if (nameSplite[2] === "1") {
        this.setState({ measuresdatamaintwo: value });
      } else if (nameSplite[2] === "2") {
        this.setState({ measuresdatamainthree: value });
      } else if (nameSplite[2] === "3") {
        this.setState({ measuresdatamainfour: value });
      } else if (nameSplite[2] === "4") {
        this.setState({ measuresdatamainfive: value });
      } else if (nameSplite[2] === "5") {
        this.setState({ measuresdatamainsix: value });
      }
    } else {
      this.setState({ measuresdatamainone: value });
      measures[0] = value;
    }
    this.setState({ measures });
  };

  changeMeasuresDec = (e) => {
    e.preventDefault();
    let measures = this.state.measures;
    let val = e.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|-\.)/, "");
    var dataName = e.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:\.\d{0,1})?)/g.exec(val);
    const value = match[1] + match[2];
    if (nameSplite[1] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      measures[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: value,
      };
      if (nameSplite[2] === "0") {
        this.setState({ measuresdatamainone: value });
      } else if (nameSplite[2] === "1") {
        this.setState({ measuresdatamaintwo: value });
      } else if (nameSplite[2] === "2") {
        this.setState({ measuresdatamainthree: value });
      } else if (nameSplite[2] === "3") {
        this.setState({ measuresdatamainfour: value });
      } else if (nameSplite[2] === "4") {
        this.setState({ measuresdatamainfive: value });
      } else if (nameSplite[2] === "5") {
        this.setState({ measuresdatamainsix: value });
      }
    } else {
      this.setState({ measuresdatamainone: value });
      measures[0] = value;
    }
    this.setState({ measures });
  };

  handleDataMain = (mainData) => {
    var materialsData = "";
    var measuresData = "";
    var workData = JSON.parse(localStorage.getItem("workData"));
    for (var i = 0; i < workData.length; i++) {
      if (parseInt(workData[i].JobTypeID) === parseInt(mainData)) {
        materialsData = workData[i].Materials;
        measuresData = workData[i].Measures;
      }
    }
    this.setState({
      typeofWork: mainData,
      measuresData: measuresData,
      materialsData: materialsData,
      materials: [],
      measures: [],
      WorkMeasureMaterialID: {},
      isError: {
        startDate: "",
        endDate: "",
        duration: "",
        customer: "",
        typeofWork: "",
        department: "",
        convRef: "",
        numbercasual: "",
        techn: "",
      },
    });
  };

  handleInputTypeChange = (event) => {
    event.preventDefault();
    var materialsData = "";
    var measuresData = "";
    var workData = JSON.parse(localStorage.getItem("workData"));
    if (this.state.typeofWork === "") {
      if (event.target.value !== "") {
        for (var i = 0; i < workData.length; i++) {
          if (
            parseInt(workData[i].JobTypeID) === parseInt(event.target.value)
          ) {
            materialsData = workData[i].Materials;
            measuresData = workData[i].Measures;
          }
        }
      }
      this.setState({
        typeofWork: event.target.value,
        measuresData: measuresData,
        materialsData: materialsData,
        WorkMeasureMaterialID: {},
        measuresdatamainone: "",
        measuresdatamaintwo: "",
        measuresdatamainthree: "",
        measuresdatamainfour: "",
        measuresdatamainfive: "",
        measuresdatamainsix: "",
        materialsdatamainone: "",
        materialsdatamaintwo: "",
        materialsdatamainthree: "",
        materialsdatamainfour: "",
        materialsdatamainfive: "",
        materialsdatamainsix: "",
        materialsdatamainwone: "",
        materialsdatamainwtwo: "",
        materialsdatamainwthree: "",
        materialsdatamainwfour: "",
        materialsdatamainwfive: "",
        materialsdatamainwsix: "",
        materials: [],
        measures: [],
        isError: {
          startDate: "",
          endDate: "",
          duration: "",
          customer: "",
          typeofWork: "",
          department: "",
          convRef: "",
          numbercasual: "",
          techn: "",
        },
      });
    } else {
      this.setState(
        {
          typeofWork: event.target.value,
          measuresData: measuresData,
          materialsData: materialsData,
          WorkMeasureMaterialID: {},
          materials: [],
          measures: [],
          measuresdatamainone: "",
          measuresdatamaintwo: "",
          measuresdatamainthree: "",
          measuresdatamainfour: "",
          measuresdatamainfive: "",
          measuresdatamainsix: "",
          materialsdatamainone: "",
          materialsdatamaintwo: "",
          materialsdatamainthree: "",
          materialsdatamainfour: "",
          materialsdatamainfive: "",
          materialsdatamainsix: "",
          materialsdatamainwone: "",
          materialsdatamainwtwo: "",
          materialsdatamainwthree: "",
          materialsdatamainwfour: "",
          materialsdatamainwfive: "",
          materialsdatamainwsix: "",
          isError: {
            startDate: "",
            endDate: "",
            duration: "",
            customer: "",
            typeofWork: "",
            department: "",
            convRef: "",
            numbercasual: "",
            techn: "",
          },
        },
        () => {
          this.handleDataMain(event.target.value);
        }
      );
      // this.setState({

      // });
    }
  };

  handleOfChange = (event) => {
    getAllCacheData();
  };

  handleInputChange = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value.toUpperCase(),
    });
  };

  handleMaterialChange = (event) => {
    event.preventDefault();
    let materials = this.state.materials;
    let inputEnabled = [...this.state.inputEnabled];
    var dataName = event.target.name;
    var nameSplite = dataName.split("-");
    if (nameSplite[2] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      materials[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: event.target.value,
      };

      inputEnabled[nameSplite[2]] = true;

      this.setState({ inputEnabled });

      this.setState({ materialsdatamainseven: event.target.value });
    } else {
      if (
        this.state.typeofWork !== "3" &&
        this.state.typeofWork !== "10" &&
        this.state.typeofWork !== "16" &&
        this.state.typeofWork !== "19" &&
        this.state.typeofWork !== "20"
      ) {
        var nameData = nameSplite[0] + nameSplite[1];
        inputEnabled[nameSplite[1]] = true;

        var WorkMeasureMaterialID = { [nameData]: event.target.value };

        this.setState({ inputEnabled });
        this.setState({ WorkMeasureMaterialID: WorkMeasureMaterialID });
      } else {
        var nameData = nameSplite[0] + nameSplite[1];
        var seconData = "value" + nameSplite[1];
        var WorkMeasureMaterialID = { [nameData]: event.target.value };
        materials[nameSplite[1]] = {
          [nameData]: event.target.value,
          [seconData]: 1,
        };

        inputEnabled[nameSplite[1]] = true;

        this.setState({ inputEnabled });
      }
    }
    this.setState({
      materials,
    });
  };

  handleMeasuresChange = (event) => {
    event.preventDefault();
    let measures = this.state.measures;
    var dataName = event.target.name;
    var nameSplite = dataName.split("-");
    if (nameSplite[1] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      measures[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: event.target.value,
      };
    } else {
      measures[0] = event.target.value;
    }
    this.setState({
      measures,
    });
  };

  handleNumberChange = (event) => {
    event.preventDefault();
    let val = event.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(0|\.)/, "");
    const match = /(\d{0,9})[^.]*((?:)?)/g.exec(val);
    const value = match[1] + match[2];
    this.setState({ [event.target.name]: value });
  };

  handleNumberMaterialChange = (event) => {
    event.preventDefault();
    let materials = this.state.materials;
    let val = event.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    // val = val.replace(/^(0|\.)/, "");
    var dataName = event.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:)?)/g.exec(val);
    // const value = match[1] + match[2];
    const value = match[1];
    if (nameSplite[2] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      materials[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: value,
      };
      if (nameSplite[2] === "0") {
        this.setState({ materialsdatamainone: value });
      } else if (nameSplite[2] === "1") {
        this.setState({ materialsdatamaintwo: value });
      } else if (nameSplite[2] === "2") {
        this.setState({ materialsdatamainthree: value });
      } else if (nameSplite[2] === "3") {
        this.setState({ materialsdatamainfour: value });
      } else if (nameSplite[2] === "4") {
        this.setState({ materialsdatamainfive: value });
      } else if (nameSplite[2] === "5") {
        this.setState({ materialsdatamainsix: value });
      }
    } else {
      var nameData = nameSplite[0] + nameSplite[1];
      var seconData = "WorkMeasureMaterialID" + nameSplite[2];
      materials[nameSplite[1]] = {
        [nameData]: value,
        [seconData]: this.state.WorkMeasureMaterialID,
      };
      if (nameSplite[1] === "0") {
        this.setState({ materialsdatamainone: value });
      } else if (nameSplite[1] === "1") {
        this.setState({ materialsdatamaintwo: value });
      } else if (nameSplite[1] === "2") {
        this.setState({ materialsdatamainthree: value });
      } else if (nameSplite[1] === "3") {
        this.setState({ materialsdatamainfour: value });
      } else if (nameSplite[1] === "4") {
        this.setState({ materialsdatamainfive: value });
      } else if (nameSplite[1] === "5") {
        this.setState({ materialsdatamainsix: value });
      }
    }
    this.setState({ materials });
  };

  handleNumberMeasuresChange = (event) => {
    event.preventDefault();
    let measures = this.state.measures;
    let val = event.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    // val = val.replace(/^(0|\.)/, "");
    var dataName = event.target.name;
    var nameSplite = dataName.split("-");
    const match = /(\d{0,9})[^.]*((?:)?)/g.exec(val);
    // const value = match[1] + match[2];
    const value = match[1];
    if (nameSplite[1] !== undefined) {
      var nameData = "WorkMeasureMaterialID" + nameSplite[2];
      var seconData = "value" + nameSplite[2];
      measures[nameSplite[2]] = {
        [nameData]: nameSplite[1],
        [seconData]: value,
      };
      if (nameSplite[2] === "0") {
        this.setState({ measuresdatamainone: value });
      } else if (nameSplite[2] === "1") {
        this.setState({ measuresdatamaintwo: value });
      } else if (nameSplite[2] === "2") {
        this.setState({ measuresdatamainthree: value });
      } else if (nameSplite[2] === "3") {
        this.setState({ measuresdatamainfour: value });
      } else if (nameSplite[2] === "4") {
        this.setState({ measuresdatamainfive: value });
      } else if (nameSplite[2] === "5") {
        this.setState({ measuresdatamainsix: value });
      }
    } else {
      this.setState({ measuresdatamainone: event.target.value });
      measures[0] = value;
    }
    this.setState({ measures });
  };

  handleNumberCasChange = (event) => {
    event.preventDefault();
    let val = event.target.value;
    val = val.replace(/([^0-9.]+)/, "");
    val = val.replace(/^(|\.)/, "");
    const match = /(\d{0,9})[^.]*((?:)?)/g.exec(val);
    const value = match[1] + match[2];
    this.setState({ numbercasual: value });
  };

  handleFormValidation = (event) => {
    let isError = this.state.isError;
    var validationcon = [];
    if (event.startDate === "") {
      isError["startDate"] = "Please enter start date";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["startDate"] = "";
      this.setState({ isError });
    }
    if (event.endDate === "") {
      isError["endDate"] = "Please enter end date";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      if (event.endDate > new Date()) {
        isError["endDate"] = "Job end time must be less than current time";
        this.setState({ isError });
        validationcon.push(1);
      } else {
        isError["endDate"] = "";
        this.setState({ isError });
      }
    }
    if (event.startDate.getTime() >= event.endDate.getTime()) {
      isError["duration"] = "Job end time must be later than job start time";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["duration"] = "";
      this.setState({ isError });
    }
    if (event.customer === "") {
      isError["customer"] = "Please select customer";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["customer"] = "";
      this.setState({ isError });
    }
    if (event.department === "") {
      isError["department"] = "Please enter department";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["department"] = "";
      this.setState({ isError });
    }
    if (event.convRef === "") {
      isError["convRef"] = "Please enter conveyor number";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["convRef"] = "";
      this.setState({ isError });
    }
    if (event.typeofWork === "") {
      isError["typeofWork"] = "Please select type of work";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["typeofWork"] = "";
      this.setState({ isError });
    }
    if (event.techn.length <= 0) {
      isError["techn"] = "Please select technicians";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["techn"] = "";
      this.setState({ isError });
    }
    if (event.numbercasual === "") {
      isError["numbercasual"] = "Please enter number of casuals";
      this.setState({ isError });
      validationcon.push(1);
    } else {
      isError["numbercasual"] = "";
      this.setState({ isError });
    }
    return validationcon;
  };

  handleFormSubmit = (event) => {
    event.preventDefault();
    var resp = this.handleFormValidation(this.state);
    if (resp.length <= 0) {
      const accesstokendata = localStorage.getItem("access_token");
      const siteID = localStorage.getItem("siteID");
      const readData = JSON.parse(accesstokendata);
      const userID = readData.userdata.user_id;

      var Technicians = this.state.techn;
      var TechniciansData = [];
      for (var i = 0; i < Technicians.length; i++) {
        var TechniciansDataMain = {};
        TechniciansDataMain["JobTechnicianID"] = 0;
        TechniciansDataMain["TechnicianID"] = parseInt(Technicians[i].id);
        TechniciansData.push(TechniciansDataMain);
      }

      var materials = this.state.materials;
      var materialsData = [];
      for (var j = 0; j < materials.length; j++) {
        var materialsDataMain = {};
        var workname = "WorkMeasureMaterialID" + j;
        let valuename = "value" + j;
        var matdata = materials[j][workname][workname];
        materialsDataMain["JobMeasureMaterialID"] = 0;
        if (matdata !== undefined) {
          materialsDataMain["WorkMeasureMaterialID"] =
            materials[j][workname][workname];
        } else {
          materialsDataMain["WorkMeasureMaterialID"] = materials[j][workname];
        }
        materialsDataMain["Value"] = materials[j][valuename];
        materialsData.push(materialsDataMain);
      }

      var measures = this.state.measures;
      var measuresData = [];
      for (var k = 0; k < measures.length; k++) {
        var measuresDataMain = {};
        var workname = "WorkMeasureMaterialID" + k;
        var valuename = "value" + k;
        measuresDataMain["JobMeasureMaterialID"] = 0;
        measuresDataMain["WorkMeasureMaterialID"] = measures[k][workname];
        measuresDataMain["Value"] = measures[k][valuename];
        measuresData.push(measuresDataMain);
      }

      var newDate = new Date();
      var dateString = Moment(newDate, "DD MM YYYY hh:mm:ss", true);
      const min = 1;
      const max = 1000;
      const rand = min + Math.random() * (max - min);
      const randString = dateString + rand;

      var submitData = {
        JobID: 0,
        SiteID: parseInt(siteID),
        CustomerID:
          this.state.customer === "" ? 0 : parseInt(this.state.customer),
        JobMaterialID: 0,
        JobTypeID:
          this.state.typeofWork === "" ? 0 : parseInt(this.state.typeofWork),
        StartDateTime: moment(this.state.startDate).format(),
        EndDateTime: moment(this.state.endDate).format(),
        Department: this.state.department,
        ConveyorReference: this.state.convRef,
        Measures: measuresData,
        Materials: materialsData,
        ModifiedBy: parseInt(userID),
        CreatedOn: new Date(),
        Technicians: TechniciansData,
        Stage: 10,
        UniqueString: randString,
        Status: 10,
        NumberOfCasuals:
          this.state.numbercasual === ""
            ? 0
            : parseInt(this.state.numbercasual),
      };
      window.scrollTo(0, 0);
      getCreateJob(submitData);
    } else {
      window.scrollTo(0, 0);
    }
  };

  handleChange = (selectedDate) => {
    var durationTime = "";
    var errorClass = "";
    const MySwal = withReactContent(Swal);
    this.setState({
      endDate: "",
    });

    if (
      selectedDate !== "" &&
      selectedDate !== null &&
      selectedDate !== undefined
    ) {
      if (selectedDate > new Date()) {
        MySwal.fire("<p>Job start time can not be later than current time<p>");
        this.setState({
          startDate: "",
          duration: 0,
          errorClass: "errorClass",
        });
        return;
      }

      const days = 86400000; //number of milliseconds in a day
      const tenDaysAgo = new Date(new Date().getDate() - 10 * days);
      //allow the user to select the start date for any time of the tenth day in the past
      const tenDaysAgoDate = new Date(
        tenDaysAgo.getYear(),
        tenDaysAgo.getMonth(),
        tenDaysAgo.getDate(),
        0,
        0,
        0
      );
      if (
        this.state.endDate !== "" &&
        this.state.endDate !== null &&
        this.state.endDate !== undefined
      ) {
        // if(selectedDate > this.state.endDate){
        var Difference_In_Time =
          this.state.endDate.getTime() - selectedDate.getTime();
        var Difference_In_Minutes = Difference_In_Time / (1000 * 60);
        var num = parseInt(Difference_In_Minutes);
        var hoursdata = num / 60;
        var hours = parseInt(hoursdata);
        var minutesdata = (hoursdata - hours) * 60;
        var minutes = parseInt(minutesdata);
        durationTime = hours + ":" + minutes;
        // if(durationTime > 0){
        // durationTime = parseInt(Difference_In_Days);
        // }else{
        //   durationTime = 0;
        // }
        // }else{
        //   durationTime = 0;
        // }
      }

      if (tenDaysAgoDate > selectedDate) {
        MySwal.fire(
          "<p>Job start time can not be more than 10 days in the past<p>"
        );
        this.setState({
          startDate: "",
          duration: 0,
          errorClass: "errorClass",
        });
        return;
      }
      if (durationTime > 0) {
        this.setState({
          startDate: selectedDate,
          duration: durationTime,
          errorClass: "",
        });
      } else {
        this.setState({
          startDate: selectedDate,
          endDate: selectedDate,
          duration: 0,
          errorClass: "errorClass",
        });
      }
    } else {
      this.setState({
        startDate: "",
        duration: "",
      });
    }
  };

  handleChangeEnd = (selectedDate) => {
    const MySwal = withReactContent(Swal);
    var errorClass = "";
    if (
      this.state.startDate !== "" &&
      this.state.startDate !== null &&
      this.state.startDate !== undefined
    ) {
      var Difference_In_Time =
        selectedDate.getTime() - this.state.startDate.getTime();
      var Difference_In_Minutes = Difference_In_Time / (1000 * 60);
      var num = parseInt(Difference_In_Minutes);
      var hoursdata = num / 60;
      var hours = parseInt(hoursdata);
      var minutesdata = (hoursdata - hours) * 60;
      var minutes = parseInt(minutesdata);
      const durationTime = hours + ":" + minutes;
      // if (selectedDate < this.state.startDate){
      //   MySwal.fire('<p>Job end time can not be earlier than start time<p>');
      //   this.setState({
      //       endDate: this.state.startDate,
      //       duration:0
      //   });
      //   return;
      // }

      // if (selectedDate > new Date()){
      //   MySwal.fire('<p>Job end time can not be later than current time<p>');
      //   this.setState({
      //       endDate: this.state.startDate,
      //       duration:0
      //   });
      //   return;
      // }
      if (hours > 0 || minutes > 0) {
        errorClass = "";
      } else {
        errorClass = "errorClass";
      }
      this.setState({
        endDate: selectedDate,
        duration: durationTime,
        errorClass: errorClass,
      });
    } else {
      MySwal.fire("<p>Please select start date first<p>");
    }
  };

  handleOnChange = (selected) => {
    this.setState({
      techn: selected,
    });
  };

  render() {
    const loadingImg = require("../../assets/images/Hourglass.gif");
    var customerDataArr = "";
    var typeofWorkDataArr = "";
    var optionsArray = [];
    var techDataMain = JSON.parse(localStorage.getItem("techData"));
    var workDataMain = JSON.parse(localStorage.getItem("workData"));
    var custDataMain = JSON.parse(localStorage.getItem("customerData"));

    if (
      techDataMain !== "" &&
      techDataMain !== null &&
      techDataMain !== undefined
    ) {
      optionsArray = JSON.parse(localStorage.getItem("techData"));
    }
    if (
      workDataMain !== "" &&
      workDataMain !== null &&
      workDataMain !== undefined
    ) {
      typeofWorkDataArr = JSON.parse(localStorage.getItem("workData"));
    }
    if (
      custDataMain !== "" &&
      custDataMain !== null &&
      custDataMain !== undefined
    ) {
      customerDataArr = JSON.parse(localStorage.getItem("customerData"));
    } else {
      customerDataArr = this.state.customerState;
    }

    return (
      <div>
        <Header />
        <div className="topcon">
          <div className="row rowDataClass d-flex justify-content-center align-items-center h-100">
            <div className="col-xl-10">
              <div className="card rounded-3 text-black">
                <div className="row rowDataClass">
                  <div className="col-lg-12">
                    <div className="card-body p-md-5 mx-md-4">
                      <form method="POST" onSubmit={this.handleFormSubmit}>
                        <div className="panel panel-default">
                          <div className="panel-heading">
                            <b>Job Start</b>
                          </div>
                          <div className="panel-body">
                            <DatePicker
                              timeIntervals={15}
                              onChange={this.handleChange}
                              selected={this.state.startDate}
                              showTimeSelect
                              dateFormat="dd-MM-yyyy hh:mm a"
                              minDate={this.state.currentdate}
                              maxDate={this.state.lasttdate}
                              className="form-control"
                              required
                              placeholderText="Date and Time *"
                            />
                          </div>
                          {this.state.isError.startDate !== "" ? (
                            <span className="tool_tip">
                              {this.state.isError.startDate}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>

                        <div className="panel panel-default">
                          <div className="panel-heading">
                            <b>Job End</b>
                          </div>
                          <div className="panel-body">
                            <DatePicker
                              timeIntervals={15}
                              onChange={this.handleChangeEnd}
                              selected={this.state.endDate}
                              showTimeSelect
                              dateFormat="dd-MM-yyyy hh:mm a"
                              minDate={this.state.currentdate}
                              maxDate={this.state.lasttdate}
                              className="form-control"
                              required
                              placeholderText="Date and Time *"
                            />
                          </div>
                          {this.state.isError.duration !== "" ? (
                            <span className="tool_tip">
                              {this.state.isError.duration}
                            </span>
                          ) : (
                            ""
                          )}
                          {this.state.isError.endDate !== "" ? (
                            <span className="tool_tip">
                              {this.state.isError.endDate}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="panel panel-default">
                          <div className="panel-heading">
                            <b>Duration (Hrs&Min): </b>
                            <span className={this.state.errorClass}>
                              {this.state.duration}
                            </span>
                          </div>
                          <div className="panel-body"></div>
                        </div>
                        <div className="panel panel-default">
                          <div className="panel-heading">
                            <b>Customer Details</b>
                          </div>
                          <div className="panel-body">
                            <FloatingLabel className="mb-3" label="">
                              <Form.Select
                                aria-label="Select Customer Name *"
                                className="select"
                                required
                                name="customer"
                                value={this.state.customer}
                                onChange={this.handleInputChange}
                              >
                                <option value="">Select Customer Name *</option>
                                {customerDataArr !== "" &&
                                customerDataArr !== null
                                  ? customerDataArr.map((customer, index) => (
                                      <option
                                        key={index}
                                        value={customer.CustomerID}
                                      >
                                        {customer.CustomerName}
                                      </option>
                                    ))
                                  : ""}
                              </Form.Select>

                              {this.state.isError.customer !== "" ? (
                                <span className="tool_tip">
                                  {this.state.isError.customer}
                                </span>
                              ) : (
                                ""
                              )}
                            </FloatingLabel>
                            <FloatingLabel
                              label="Department *"
                              className="mb-3"
                            >
                              <Form.Control
                                type="text"
                                maxLength="50"
                                required
                                name="department"
                                className="input-up"
                                value={this.state.department}
                                onChange={this.handleInputChange}
                                placeholder="Department (max 50 charcter) "
                              />
                              {this.state.isError.department !== "" ? (
                                <span className="tool_tip">
                                  {this.state.isError.department}
                                </span>
                              ) : (
                                ""
                              )}
                            </FloatingLabel>
                            <FloatingLabel label="Conveyor Number *">
                              <Form.Control
                                type="text"
                                maxLength="50"
                                required
                                name="convRef"
                                className="input-up"
                                value={this.state.convRef}
                                onChange={this.handleInputChange}
                                placeholder="Conveyor Number"
                              />
                              {this.state.isError.convRef !== "" ? (
                                <span className="tool_tip">
                                  {this.state.isError.convRef}
                                </span>
                              ) : (
                                ""
                              )}
                            </FloatingLabel>
                          </div>
                        </div>

                        <div className="panel panel-default">
                          <div className="panel-heading">
                            <b>Work Details</b>
                          </div>
                          <div className="panel-body">
                            <FloatingLabel label="">
                              <Form.Select
                                aria-label="Select Type of work *"
                                required
                                name="typeofWork"
                                className="select"
                                value={this.state.typeofWork}
                                onChange={this.handleInputTypeChange}
                              >
                                <option value="">Select Type of work *</option>
                                {typeofWorkDataArr !== "" &&
                                typeofWorkDataArr !== null
                                  ? typeofWorkDataArr.map(
                                      (typeofwork, indexwork) => (
                                        <option
                                          key={typeofwork.JobTypeID}
                                          value={typeofwork.JobTypeID}
                                        >
                                          {typeofwork.JobType}
                                        </option>
                                      )
                                    )
                                  : ""}
                              </Form.Select>
                              {this.state.isError.convRef !== "" ? (
                                <span className="tool_tip">
                                  {this.state.isError.convRef}
                                </span>
                              ) : (
                                ""
                              )}
                            </FloatingLabel>
                          </div>
                        </div>

                        <div className="panel panel-default">
                          <div className="panel-heading">
                            <b>Material Details</b>
                          </div>
                          <div className="panel-body">
                            {this.state.measuresData !== ""
                              ? this.state.measuresData.map(
                                  (measures, indexmain) =>
                                    measures.DataType === "Char" ? (
                                      <FloatingLabel
                                        key={indexmain}
                                        className="mb-3"
                                        label={
                                          measures.Required === 1
                                            ? measures.UoM !== ""
                                              ? measures.MeasureName +
                                                " (" +
                                                measures.UoM +
                                                ") *"
                                              : measures.MeasureName + " *"
                                            : measures.UoM !== ""
                                            ? measures.MeasureName +
                                              " (" +
                                              measures.UoM +
                                              ")"
                                            : measures.MeasureName
                                        }
                                      >
                                        <Form.Control
                                          type="text"
                                          maxLength="100"
                                          required={
                                            measures.Required === 1
                                              ? true
                                              : false
                                          }
                                          name={
                                            "value" +
                                            "-" +
                                            measures.WorkMeasureMaterialId +
                                            "-" +
                                            indexmain
                                          }
                                          value={
                                            indexmain === 0
                                              ? this.state.measuresdatamainone
                                              : indexmain === 1
                                              ? this.state.measuresdatamaintwo
                                              : indexmain === 2
                                              ? this.state.measuresdatamainthree
                                              : indexmain === 3
                                              ? this.state.measuresdatamainfour
                                              : indexmain === 4
                                              ? this.state.measuresdatamainfive
                                              : indexmain === 5
                                              ? this.state.measuresdatamainsix
                                              : ""
                                          }
                                          onChange={this.handleMeasuresChange}
                                          placeholder={
                                            measures.MeasureName +
                                            " (" +
                                            measures.UoM +
                                            ")"
                                          }
                                        />
                                      </FloatingLabel>
                                    ) : (
                                      <FloatingLabel
                                        key={indexmain + 1}
                                        className="mb-3"
                                        label={
                                          measures.Required === 1
                                            ? measures.UoM !== ""
                                              ? measures.MeasureName +
                                                " (" +
                                                measures.UoM +
                                                ") *"
                                              : measures.MeasureName + " *"
                                            : measures.UoM !== ""
                                            ? measures.MeasureName +
                                              " (" +
                                              measures.UoM +
                                              ")"
                                            : measures.MeasureName
                                        }
                                      >
                                        <Form.Control
                                          type="number"
                                          required={
                                            measures.Required === 1
                                              ? true
                                              : false
                                          }
                                          name={
                                            "value" +
                                            "-" +
                                            measures.WorkMeasureMaterialId +
                                            "-" +
                                            indexmain
                                          }
                                          onWheel={(e) => e.target.blur()}
                                          onChange={
                                            measures.DataType === "Int"
                                              ? this.handleNumberMeasuresChange
                                              : measures.DataType === "Dec1"
                                              ? this.changeMeasuresDec
                                              : this.changeMeasures
                                          }
                                          step={
                                            measures.DataType === "Int"
                                              ? ""
                                              : "0.0000001"
                                          }
                                          value={
                                            indexmain === 0
                                              ? this.state.measuresdatamainone
                                              : indexmain === 1
                                              ? this.state.measuresdatamaintwo
                                              : indexmain === 2
                                              ? this.state.measuresdatamainthree
                                              : indexmain === 3
                                              ? this.state.measuresdatamainfour
                                              : indexmain === 4
                                              ? this.state.measuresdatamainfive
                                              : indexmain === 5
                                              ? this.state.measuresdatamainsix
                                              : ""
                                          }
                                          placeholder={
                                            measures.MeasureName +
                                            " (" +
                                            measures.UoM +
                                            ")"
                                          }
                                        />
                                      </FloatingLabel>
                                    )
                                )
                              : ""}

                            {this.state.materialsData !== ""
                              ? this.state.materialsData.map(
                                  (materials, index) => (
                                    <span key={index}>
                                      {materials.MaterialDetails.length > 1 ? (
                                        <span>
                                          <FloatingLabel
                                            className="mb-3"
                                            label=""
                                            key={index}
                                          >
                                            <Form.Select
                                              aria-label={
                                                materials.MaterialType
                                              }
                                              required
                                              name={
                                                "WorkMeasureMaterialID" +
                                                "-" +
                                                index
                                              }
                                              className="select"
                                              onChange={
                                                this.handleMaterialChange
                                              }
                                            >
                                              <option value="">
                                                {materials.Required === 1
                                                  ? "Select Type of " +
                                                    materials.MaterialType +
                                                    " *"
                                                  : "Select Type of " +
                                                    materials.MaterialType}
                                              </option>
                                              {materials.MaterialDetails.map(
                                                (
                                                  materialdetails,
                                                  indexoption
                                                ) => (
                                                  <option
                                                    key={indexoption}
                                                    value={
                                                      materialdetails.WorkMeasureMaterialId
                                                    }
                                                  >
                                                    {
                                                      materialdetails.MaterialName
                                                    }
                                                  </option>
                                                )
                                              )}
                                            </Form.Select>
                                          </FloatingLabel>
                                          {this.state.typeofWork !== "3" &&
                                          this.state.typeofWork !== "10" &&
                                          this.state.typeofWork !== "16" &&
                                          this.state.typeofWork !== "19" &&
                                          this.state.typeofWork !== "20" ? (
                                            <FloatingLabel
                                              className="mb-3"
                                              key={index + 1}
                                              label={
                                                materials.Required === 1
                                                  ? materials.UoM !== ""
                                                    ? materials.MaterialType +
                                                      " (" +
                                                      materials.UoM +
                                                      ") *"
                                                    : materials.MaterialType +
                                                      " *"
                                                  : materials.UoM !== ""
                                                  ? materials.MaterialType +
                                                    " (" +
                                                    materials.UoM +
                                                    ")"
                                                  : materials.MaterialType
                                              }
                                            >
                                              <Form.Control
                                                type="number"
                                                required={
                                                  materials.Required === 1
                                                    ? true
                                                    : false
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                name={"value" + "-" + index}
                                                onChange={
                                                  materials.DataType === "Int"
                                                    ? this
                                                        .handleNumberMaterialChange
                                                    : materials.DataType ===
                                                      "Dec1"
                                                    ? this.changeMaterialsDec
                                                    : this.changeMaterials
                                                }
                                                disabled={
                                                  !this.state.inputEnabled[
                                                    index
                                                  ]
                                                }
                                                placeholder={
                                                  materials.UoM !== ""
                                                    ? materials.MaterialType +
                                                      " (" +
                                                      materials.UoM +
                                                      ")"
                                                    : materials.MaterialType
                                                }
                                                value={
                                                  index === 0
                                                    ? this.state
                                                        .materialsdatamainwone
                                                    : index === 1
                                                    ? this.state
                                                        .materialsdatamainwtwo
                                                    : index === 2
                                                    ? this.state
                                                        .materialsdatamainwthree
                                                    : index === 3
                                                    ? this.state
                                                        .materialsdatamainwfour
                                                    : index === 4
                                                    ? this.state
                                                        .materialsdatamainwfive
                                                    : index === 5
                                                    ? this.state
                                                        .materialsdatamainwsix
                                                    : ""
                                                }
                                                step={
                                                  materials.DataType === "Int"
                                                    ? ""
                                                    : "0.0000001"
                                                }
                                              />
                                            </FloatingLabel>
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      ) : (
                                        materials.MaterialDetails.map(
                                          (materialdetails, indexdata) => (
                                            <span>
                                              {materialdetails.DataType ===
                                              "Char" ? (
                                                <FloatingLabel
                                                  key={indexdata}
                                                  className="mb-3"
                                                  label={
                                                    materialdetails.Required ===
                                                    1
                                                      ? materialdetails.UoM !==
                                                        ""
                                                        ? materialdetails.MaterialName +
                                                          " (" +
                                                          materialdetails.UoM +
                                                          ") *"
                                                        : materialdetails.MaterialName +
                                                          " *"
                                                      : materialdetails.UoM !==
                                                        ""
                                                      ? materialdetails.MaterialName +
                                                        " (" +
                                                        materialdetails.UoM +
                                                        ")"
                                                      : materialdetails.MaterialName
                                                  }
                                                >
                                                  <Form.Control
                                                    type="text"
                                                    key={indexdata}
                                                    maxLength="100"
                                                    required={
                                                      materialdetails.Required ===
                                                      1
                                                        ? true
                                                        : false
                                                    }
                                                    name={
                                                      "value" +
                                                      "-" +
                                                      materialdetails.WorkMeasureMaterialId +
                                                      "-" +
                                                      index
                                                    }
                                                    onChange={
                                                      this.handleMaterialChange
                                                    }
                                                    placeholder={
                                                      materialdetails.MaterialName
                                                    }
                                                  />
                                                </FloatingLabel>
                                              ) : (
                                                <FloatingLabel
                                                  key={indexdata + 1}
                                                  className="mb-3"
                                                  label={
                                                    materialdetails.Required ===
                                                    1
                                                      ? materialdetails.UoM !==
                                                        ""
                                                        ? materialdetails.MaterialName +
                                                          " (" +
                                                          materialdetails.UoM +
                                                          ") *"
                                                        : materialdetails.MaterialName +
                                                          " *"
                                                      : materialdetails.UoM !==
                                                        ""
                                                      ? materialdetails.MaterialName +
                                                        " (" +
                                                        materialdetails.UoM +
                                                        ")"
                                                      : materialdetails.MaterialName
                                                  }
                                                >
                                                  <Form.Control
                                                    type="number"
                                                    onWheel={(e) =>
                                                      e.target.blur()
                                                    }
                                                    required={
                                                      materialdetails.Required ===
                                                      1
                                                        ? true
                                                        : false
                                                    }
                                                    name={
                                                      "value" +
                                                      "-" +
                                                      materialdetails.WorkMeasureMaterialId +
                                                      "-" +
                                                      index
                                                    }
                                                    onChange={
                                                      materialdetails.DataType ===
                                                      "Int"
                                                        ? this
                                                            .handleNumberMaterialChange
                                                        : materialdetails.DataType ===
                                                          "Dec1"
                                                        ? this
                                                            .changeMaterialsDec
                                                        : this.changeMaterials
                                                    }
                                                    placeholder={
                                                      materialdetails.MaterialName +
                                                      " (" +
                                                      materialdetails.UoM +
                                                      ")"
                                                    }
                                                    value={
                                                      index === 0
                                                        ? this.state
                                                            .materialsdatamainone
                                                        : index === 1
                                                        ? this.state
                                                            .materialsdatamaintwo
                                                        : index === 2
                                                        ? this.state
                                                            .materialsdatamainthree
                                                        : index === 3
                                                        ? this.state
                                                            .materialsdatamainfour
                                                        : index === 4
                                                        ? this.state
                                                            .materialsdatamainfive
                                                        : index === 5
                                                        ? this.state
                                                            .materialsdatamainsix
                                                        : ""
                                                    }
                                                    step={
                                                      materials.DataType ===
                                                      "Int"
                                                        ? ""
                                                        : "0.0000001"
                                                    }
                                                  />
                                                </FloatingLabel>
                                              )}
                                            </span>
                                          )
                                        )
                                      )}
                                    </span>
                                  )
                                )
                              : ""}
                          </div>
                        </div>

                        <div className="panel panel-default">
                          <div className="panel-heading">
                            <b>Technician(s) *</b>
                          </div>
                          <div className="panel-body">
                            <FloatingLabel className="mb-3">
                              <Multiselect
                                required
                                options={optionsArray}
                                selectedValues={this.state.techn}
                                onSelect={this.handleOnChange}
                                onRemove={this.handleOnChange}
                                displayValue="name"
                                placeholder="Technician(s) *"
                                showCheckbox={true}
                              />
                              {this.state.isError.techn !== "" ? (
                                <span className="tool_tip">
                                  {this.state.isError.techn}
                                </span>
                              ) : (
                                ""
                              )}
                            </FloatingLabel>
                            <FloatingLabel label="Number of Casual(s) * ">
                              <Form.Control
                                type="number"
                                required
                                name="numbercasual"
                                value={this.state.numbercasual}
                                onWheel={(e) => e.target.blur()}
                                onChange={this.handleNumberCasChange}
                                placeholder="Number of Casual(s) * "
                              />
                              {this.state.isError.numbercasual !== "" ? (
                                <span className="tool_tip">
                                  {this.state.isError.numbercasual}
                                </span>
                              ) : (
                                ""
                              )}
                            </FloatingLabel>
                          </div>
                        </div>

                        <div className="text-center pt-1 mb-5 pb-1">
                          <button
                            className="btn btn-primary btn-block bt-lg"
                            disabled={this.state.submitbutton}
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.lodingImagData === true ? (
          <span className="preloader">
            <img src={loadingImg} className="loaderImg" />
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }
}
